/* eslint-disable */ 
/**
 * 获取url参数的方法
 * @param qs
 * @returns {{}}
 */
export function getQueryParams (qs) {
  const params = {};
  const re = /[?&]?([^=]+)=([^&]*)/g;
  let tokens;
  if (qs) {
    qs = qs.split('+').join(' ');

    while (tokens = re.exec(qs)) {
      params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }
  }
  return params;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js